import { IS_NA } from "helpers/application"

export const sizeChart = () => [
  {
    circumference: "44.2",
    diameter: "14.1",
    size: IS_NA() ? "3.00" : "F",
  },
  {
    circumference: "45.5",
    diameter: "14.5",
    size: IS_NA() ? "3.50" : "G",
  },
  {
    circumference: "46.8",
    diameter: "14.9",
    size: IS_NA() ? "4.00" : "H",
  },
  {
    circumference: "48.0",
    diameter: "15.3",
    size: IS_NA() ? "4.50" : "I",
  },
  {
    circumference: "49.3",
    diameter: "15.7",
    size: IS_NA() ? "5.00" : "J 1/2",
  },
  {
    circumference: "50.6",
    diameter: "16.1",
    size: IS_NA() ? "5.50" : "K 1/2",
  },

  {
    circumference: "51.9",
    diameter: "16.5",
    size: IS_NA() ? "6.00" : "L 1/2",
  },
  {
    circumference: "53.1",
    diameter: "16.9",
    size: IS_NA() ? "6.50" : "M 1/2",
  },
  {
    circumference: "54.4",
    diameter: "17.3",
    size: IS_NA() ? "7.00" : "N 1/2",
  },
  {
    circumference: "55.7",
    diameter: "17.7",
    size: IS_NA() ? "7.50" : "O 1/2",
  },
  {
    circumference: "57.0",
    diameter: "18.1",
    size: IS_NA() ? "8.00" : "P 1/2",
  },
  {
    circumference: "58.3",
    diameter: "18.5",
    size: IS_NA() ? "8.50" : "Q 1/2",
  },

  {
    circumference: "59.5",
    diameter: "19.0",
    size: IS_NA() ? "9.00" : "R 1/2",
  },
  {
    circumference: "60.8",
    diameter: "19.4",
    size: IS_NA() ? "9.50" : "S 1/2",
  },
  {
    circumference: "62.1",
    diameter: "19.8",
    size: IS_NA() ? "10.00" : "T 1/2",
  },
  {
    circumference: "63.4",
    diameter: "20.2",
    size: IS_NA() ? "10.50" : "U 1/2",
  },
  {
    circumference: "64.6",
    diameter: "20.6",
    size: IS_NA() ? "11.00" : "V 1/2",
  },
  {
    circumference: "65.9",
    diameter: "21.0",
    size: IS_NA() ? "11.50" : "W 1/2",
  },
  {
    circumference: "67.2",
    diameter: "21.4",
    size: IS_NA() ? "12.00" : "X 1/2",
  },
  {
    circumference: "68.5",
    diameter: "21.8",
    size: IS_NA() ? "12.50" : "Z",
  },
  {
    circumference: "69.7",
    diameter: "22.2",
    size: IS_NA() ? "13.00" : "Z1",
  },
  {
    circumference: "71.0",
    diameter: "22.6",
    size: IS_NA() ? "13.50" : "Z2",
  },
  {
    circumference: "72.3",
    diameter: "23.0",
    size: IS_NA() ? "14.00" : "Z3",
  },
  {
    circumference: "73.6",
    diameter: "23.4",
    size: IS_NA() ? "14.50" : "Z4",
  },
  {
    circumference: "74.8",
    diameter: "23.8",
    size: IS_NA() ? "15.00" : "Z5",
  },
]

export const averageRingSize = () => ({
  men: IS_NA() ? "10.00" : <>T &frac12;</>,
  women: IS_NA() ? "7.00" : <>N &frac12;</>,
})
